// store/persist/idbStorage.js

import {
  saveData,
  loadData,
  clearAllData,
} from "../../services/IndexedDBService";

// JSON storage adapter compatible with zustand's createJSONStorage
const STORAGE_KEY = "appStore";

export const idbJSONStorage = {
  // Return string | null (zustand supports async here)
  async getItem(name) {
    try {
      const res = await loadData(name);
      return res ? JSON.stringify(res.data) : null;
    } catch (err) {
      console.warn("idbStorage.getItem failed, returning null:", err?.message || err);
      return null;
    }
  },
  async setItem(name, value) {
    try {
      await saveData(name, JSON.parse(value));
    } catch (err) {
      console.warn("idbStorage.setItem failed, skipping persist:", err?.message || err);
    }
  },
  async removeItem(name) {
    try {
      if (name === STORAGE_KEY) {
        await clearAllData();
      } else {
        await saveData(name, null);
      }
    } catch (err) {
      console.warn("idbStorage.removeItem failed:", err?.message || err);
    }
  },
};

export const STORAGE_NAME = STORAGE_KEY;
